import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { AdminAddLoadComponent } from "../admin-add-load/admin-add-load.component";
import { AdminService } from "../admin.service";
import { CommonHelperComponent } from "src/app/common-helper/common-helper.component";

@Component({
  selector: "app-admin-load",
  templateUrl: "./admin-load.component.html",
  styleUrls: ["./admin-load.component.css"],
})
export class AdminLoadComponent implements OnInit {
  loadType: any = "Commercial";
  matDialogref: MatDialogRef<AdminAddLoadComponent> | undefined;
  commercialLoadDetails: any;
  nonCommercialLoad: any;
  token: any;
  deleteLoadType: any;
  searchLoadType: any = -1;
  searchButton: boolean = true;
  toggleSearch: boolean = false;
  perPage: any = 10;
  page: any = 1;
  document_array: any = [];
  fetch_page: any = 0;
  currentPage: any = 0;
  startPage: any = 1;
  last_page: any = 1;
  loading: boolean = false;
  loadDetails: any = [];
  commericial: boolean = true;
  non_commericial: boolean = false;
  clear_Btn: boolean = false;
  search_Btn: boolean = false;
  search_Number: any;
  isInputValid: boolean = false;
  previousValue: string = "";
  @ViewChild("newItem") newItem: ElementRef;
  @ViewChild("newItem", { static: false }) inputElement!: ElementRef;

  constructor(
    private matDialog: MatDialog,
    private services: AdminService,
    private router: Router,
    private snackBar: MatSnackBar
  ) {}

  ngOnInit(): void {
    this.token = localStorage.getItem("adminToken");
    this.pagination(1);
    this.GetLoadDetails(this.searchLoadType);
    let triptype = "loads";
    localStorage.setItem("tripType", triptype);
  }

  onInputChange(value: any) {
    const previousLength = this.previousValue.length;
    this.previousValue = value;
    if (
      value.length < previousLength ||
      (value.length > previousLength && this.clear_Btn)
    ) {
      this.searchLoadType = -1;
      this.GetLoadDetails(this.searchLoadType);
      this.fetch_page = 0;
      this.pagination(1);
      this.search_Btn = true;
      this.clear_Btn = false;
    }
    if (value.length >= 1) {
      this.isInputValid = true;
    } else {
      this.resetTruckTrackInfo();
    }
  }

  public GetLoadDetails(type: any) {
    this.searchLoadType = type;
    this.loading = true;
    this.services
      .GetLoadDetails(this.token, this.searchLoadType, this.perPage, this.page)
      .subscribe(
        (response: any) => {
          if (response.status === 200) {
            this.loading = false;
            this.loadDetails = response.body.data;
            this.commercialLoadDetails = response.body.data.find((ele: any) => {
              return ele.load_category === "Commercial";
            });
            this.nonCommercialLoad = response.body.data.find((ele: any) => {
              return ele.load_category === "Non-Commercial";
            });
          }
        },
        (error) => {
          this.loading = false;
          this.commericial = true;
          if (error.error.message === "jwt malformed") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          if (error.error.message === "jwt expired") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          if (error.error.message === "invalid signature") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          this.snackBar.open(error.error.message, "Fail", {
            duration: 5000,
          });
        }
      );
  }

  public getLoadsList(selectedLoadType: any) {
    this.loadType = selectedLoadType;
    if (this.loadType == "Commercial") {
      this.commericial = true;
      this.non_commericial = false;
      this.resetTruckTrackInfo();
      this.GetLoadDetails(this.searchLoadType);
      this.isInputValid = false;
    } else if (this.loadType == "Non-Commercial") {
      this.non_commericial = true;
      this.commericial = false;
      this.resetTruckTrackInfo();
      this.GetLoadDetails(this.searchLoadType);
      this.isInputValid = false;
    }
  }

  public addLoad(type: any, data: any) {
    this.matDialogref = this.matDialog.open(AdminAddLoadComponent, {
      width: "40vw",
      height: "65vh",
      data: {
        type: type,
        details: {
          loadId: data?._id,
          loadCategory: this.loadType,
          loadType: data?.material_type,
        },
      },
      autoFocus: false,
    });
    this.matDialogref.afterClosed().subscribe((data) => {
      this.GetLoadDetails(this.searchLoadType);
    });
  }

  public deleteLoadDetails(data: any, index: number) {
    const dialogRef = this.matDialog.open(CommonHelperComponent, {
      data: {
        message: 'Are you sure you want to delete this record?'
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === 'yes') {
        this.deleteLoadType = data.material_type[index].name;
        data.material_type.splice(index, 1);
        this.services
          .DeleteLoadDetails(data._id, this.token, this.deleteLoadType)
          .subscribe(
            (response: any) => {
              if (response.status === 200) {
                this.GetLoadDetails(this.searchLoadType);
                window.location.reload();
              }
            },
            (error) => {
              if (error.error.message === "jwt malformed") {
                this.router.navigateByUrl("admin/login");
                window.localStorage.clear();
              }
              if (error.error.message === "jwt expired") {
                this.router.navigateByUrl("admin/login");
                window.localStorage.clear();
              }
              if (error.error.message === "invalid signature") {
                this.router.navigateByUrl("admin/login");
                window.localStorage.clear();
              }
              this.snackBar.open(error.error.message, "Fail", {
                duration: 5000,
              });
            }
          );
      }
    });
  }

  pagination(page_status: any) {
    if (page_status == "-1") {
      this.fetch_page = parseInt(this.fetch_page) - 1;
      this.currentPage = this.fetch_page;
      this.startPage = this.currentPage;
    }
    if (page_status == "1") {
      this.currentPage = parseInt(this.fetch_page) + 1;
      this.fetch_page = this.currentPage;
      this.startPage = this.fetch_page;
    }
    if (page_status == "first") {
      this.fetch_page = this.document_array[0].currentPage;
      this.startPage = this.document_array[0].currentPage;
    }
    if (page_status == "last") {
      this.fetch_page = this.document_array[0].lastPage;
      this.startPage = this.document_array[0].lastPage;
    }
    this.GetLoadDetails(this.searchLoadType);
  }

  openSearch() {
    this.toggleSearch = true;
    this.searchButton = false;
    this.search_Btn = true;
    this.clear_Btn = false;
    if (this.toggleSearch) {
      setTimeout(() => this.inputElement.nativeElement.focus(), 0);
    }
  }

  search(value: string) {
    const words = value.toLowerCase().split(" ");
    const capitalizedValue = words
      .map((word: any) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");

    if (value != "") {
      this.searchButton = false;
      this.search_Btn = false;
      this.toggleSearch = true;
      this.clear_Btn = true;
      this.GetLoadDetails(capitalizedValue);
    } else {
      this.searchButton = true;
      this.toggleSearch = false;
      this.GetLoadDetails(this.searchLoadType);
    }
  }
  resetTruckTrackInfo() {
    this.search_Number = "";
    this.searchLoadType = -1;
    this.GetLoadDetails(this.searchLoadType);
    this.searchButton = true;
    this.toggleSearch = false;
    this.clear_Btn = false;
  }
}
